import React from 'react';

const UploadIcon = ({ width = 10, height = 10, color = 'black', ...rest }) => {
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M14 10.4004V13.0671C14 13.4207 13.8595 13.7598 13.6095 14.0099C13.3594 14.2599 13.0203 14.4004 12.6667 14.4004H3.33333C2.97971 14.4004 2.64057 14.2599 2.39052 14.0099C2.14048 13.7598 2 13.4207 2 13.0671V10.4004"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.3334 5.73372L8.00002 2.40039L4.66669 5.73372" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 2.40039V10.4004" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default UploadIcon;
